module.exports = __webpack_public_path__ + "img/simi-thumbnail.ec871971.png";